// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@conklin/Overrides/Components/Carousel";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

const sharedArrowWrapperStyles = css`
    position: absolute;
    height: 100%;
    top: 0;
`;

const sharedArrowStyles = css`
    &&& {
        border: 0;
        padding: 0;
        border: 1px solid ${color("text.main", 0.75)};
        padding: 1px;
        background-clip: content-box;
        background-color: ${color("text.main", 0.75)};
        width: 50px;
        height: 50px;
        border-radius: 50px;
        &:not(:disabled):hover,
        &:not(:disabled):focus {
            border: 1px solid ${color("common.ui10")};
            background-clip: content-box;
            background-color: ${color("common.ui10")};
            & > ${IconWrapper} {
                color: ${color("common.white")};
            }
        }
    }
`;

carouselStyles.prevArrowWrapper = {
    css: css`
        ${sharedArrowWrapperStyles}
        left: 10px;
    `,
};

carouselStyles.nextArrowWrapper = {
    css: css`
        ${sharedArrowWrapperStyles}
        right: 60px;
    `,
};

carouselStyles.carouselWrapper = {
    css: css`
        width: 100%;
        padding-right: 15px;
    `,
};

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        position: relative;
        margin: 0 auto;
        max-width: 1600px;
    `,
};

carouselStyles.prevArrowButton = {
    css: css`
        ${sharedArrowStyles}
        ${IconWrapper} {
            margin-right: 3px;
        }
    `,
};

carouselStyles.nextArrowButton = {
    css: css`
        ${sharedArrowStyles}
        ${IconWrapper} {
            margin-left: 3px;
        }
    `,
};
